import { WorkplaceFields } from "../../api/graphql/workplaces";
import { getWorkplaceChildren } from "../../components/Workplaces/helpers/getWorkplaceChildren";

/**
 * Recursively collects all children and nested children of a workplace.
 * @param workplace The workplace to start from.
 * @returns A flat array of all descendant workplaces.
 */
export const collectAllChildren = (
  workplace: WorkplaceFields
): WorkplaceFields[] => {
  const childrenItems: WorkplaceFields[] = [];
  const children = getWorkplaceChildren(workplace);

  children.forEach((type) => {
    type?.forEach((child) => {
      childrenItems.push(child);
      childrenItems.push(...collectAllChildren(child));
    });
  });

  return childrenItems;
};
